import React, {Component} from 'react';

export default class SellerProductsSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
    };

    getSearchParams(params = {}) {
         let searchType = params.searchType ? params.searchType : this.props.searchType;
         var searchBoxParams = { };
         const fieldsToInclude =  ['id','Price',
           'TransactionOrProductStatus', 'ChangeLog',
           'ProductName', 'Status','LatestSaleTransaction','PayoutAmount']

        if (searchType == 'OnSale') {
            searchBoxParams =_.extend( searchBoxParams, {
                    fromQuantity:1,
                  status:null,
                   Statuses:['Active'],
                   sortBy:  'createdAt' + ':' + (-1),
                   projectQuery:fieldsToInclude.concat(['ProductVariants']),
                  addFields:[  'PayoutAmount']
            });
        } else  if (searchType == 'Pending') {
          searchBoxParams.LatestSaleTransactionStatuses = ['Pending', 'PendingReturn','PendingPayout']
          searchBoxParams.projectQuery = fieldsToInclude;
        }else  if (searchType == 'Sold') {
          searchBoxParams.LatestSaleTransactionStatuses = ['Sold']
          searchBoxParams.projectQuery = fieldsToInclude.concat(['FundsAvailableForPaymentAt']);
        }else  if (searchType == 'Complete') {
          searchBoxParams.projectQuery = fieldsToInclude
          searchBoxParams.LatestSaleTransactionStatuses = ['Paid', 'Returned']
        }
         return searchBoxParams
    }

    render() {
        return (
            <div className="product-search-block bot30">
                    <button className={this.props.searchType == 'OnSale' ? 'active' : ''}  onClick={() => {
                      this.props.onSearchTypeChange('OnSale' );

                    }}>
                        On Sale
                        </button>
                <button className={this.props.searchType == 'Pending' ? 'active' : ''}  onClick={() => {
                 this.props.onSearchTypeChange('Pending');
                }}>
                  Pending
                </button>
                <button className={this.props.searchType == 'Sold' ? 'active' : ''}  onClick={() => {
                 this.props.onSearchTypeChange('Sold');
                }}>
                    Sold
                </button>
                <button className={this.props.searchType == 'Complete' ? 'active' : ''}  onClick={() => {
                 this.props.onSearchTypeChange('Complete');
                }}>
                    Complete
                </button>
                        </div>

        );
    }
}